import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledForm = styled.div`
    display: flex;
    flex: 1;
    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: 434px;
    }

    form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
        flex: 1;
        margin-bottom: 6rem;
        @media screen and (min-width: ${theme.breakpoints[0]}) {
            margin-bottom: 0;
        }
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        form {
            display: initial;
            height: initial;
            flex: 1;
        }
    }

    .form__radio-list {
        margin-top: 1rem;
    }

    .form__radio {
        width: 100%;
        border: 0;

        & + .form__radio {
            border-top: 1px solid rgba(22, 22, 22, 0.24);
            margin-top: 20px;
            padding-top: 20px;
        }
    }

    .form__radio:last-child {
        border-bottom: 0;
    }

    .help-button {
        display: flex;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;
        justify-content: flex-start;
        width: auto;
        margin-left: -1.5em;
        margin-bottom: 1.5em;
    }
`

export const Content = styled.div`
    text-align: center;
    margin-bottom: 52px;

    & > p:first-child {
        margin-bottom: 12px;
    }
`

export const LoadingContainer = styled.div`
    display: flex;
    height: 10rem;
    justify-content: center;
    align-items: center;
`
